import { maybeAutoboot } from "./showcase-autoboot"

export { parseShowcaseConfig, bootShowcaseLauncher } from "./showcase-autoboot"
export type { ShowcaseAutobootConfig } from "./showcase-autoboot"

const bootingScript =
  typeof document !== "undefined" ? document.currentScript : null

if (typeof window !== "undefined") {
  maybeAutoboot(bootingScript)
}
